import { ROUTE_NAMES } from '@/router/router-names';

export const MENU_ITEMS = {
    PAGE_DASHBOARD: {
        label: ROUTE_NAMES.PAGE_DASHBOARD.label,
        icon: ROUTE_NAMES.PAGE_DASHBOARD.iconName,
        to: ROUTE_NAMES.PAGE_DASHBOARD.routeName,
        role: ROUTE_NAMES.PAGE_DASHBOARD.role,
    },
    PAGE_USERS: {
        label: ROUTE_NAMES.PAGE_USERS.label,
        icon: ROUTE_NAMES.PAGE_USERS.iconName,
        to: ROUTE_NAMES.PAGE_USERS.routeName,
        role: ROUTE_NAMES.PAGE_USERS.role,
    },
    GAMES_PAGE: {
        label: ROUTE_NAMES.PAGE_GAMES.label,
        icon: ROUTE_NAMES.PAGE_GAMES.iconName,
        to: ROUTE_NAMES.PAGE_GAMES.routeName,
        role: ROUTE_NAMES.PAGE_GAMES.role,
    },
    PAGE_PAYMENT_SYSTEMS: {
        label: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.label,
        icon: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.iconName,
        to: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.routeName,
        role: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.role,
    },
    PAGE_PAYMENTS: {
        label: ROUTE_NAMES.PAGE_PAYMENTS.label,
        icon: ROUTE_NAMES.PAGE_PAYMENTS.iconName,
        to: ROUTE_NAMES.PAGE_PAYMENTS.routeName,
        role: ROUTE_NAMES.PAGE_PAYMENTS.role,
    },
    PAGE_REFERRAL: {
        label: ROUTE_NAMES.PAGE_REFERRAL.label,
        icon: ROUTE_NAMES.PAGE_REFERRAL.iconName,
        to: ROUTE_NAMES.PAGE_REFERRAL.routeName,
        role: ROUTE_NAMES.PAGE_REFERRAL.role,
    },
    PAGE_PARTNERS_PROGRAM: {
        label: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.label,
        icon: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.iconName,
        to: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.routeName,
        role: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.role,
    },
    PAGE_CMS: {
        label: ROUTE_NAMES.PAGE_CMS.label,
        icon: ROUTE_NAMES.PAGE_CMS.iconName,
        to: ROUTE_NAMES.PAGE_CMS.routeName,
        role: ROUTE_NAMES.PAGE_CMS.role,
    },
    PAGE_CHAT: {
        label: ROUTE_NAMES.PAGE_CHAT.label,
        icon: ROUTE_NAMES.PAGE_CHAT.iconName,
        to: ROUTE_NAMES.PAGE_CHAT.routeName,
        role: ROUTE_NAMES.PAGE_CHAT.role,
    },
    PAGE_BONUS: {
        label: ROUTE_NAMES.PAGE_BONUS.label,
        icon: ROUTE_NAMES.PAGE_BONUS.iconName,
        to: ROUTE_NAMES.PAGE_BONUS.routeName,
        role: ROUTE_NAMES.PAGE_BONUS.role,
    },
    PAGE_MISSIONS: {
        label: ROUTE_NAMES.PAGE_MISSIONS.label,
        icon: ROUTE_NAMES.PAGE_MISSIONS.iconName,
        to: ROUTE_NAMES.PAGE_MISSIONS.routeName,
        role: ROUTE_NAMES.PAGE_MISSIONS.role,
    },
    PAGE_TRANSLATIONS: {
        label: ROUTE_NAMES.PAGE_TRANSLATIONS.label,
        icon: ROUTE_NAMES.PAGE_TRANSLATIONS.iconName,
        to: ROUTE_NAMES.PAGE_TRANSLATIONS.routeName,
        role: ROUTE_NAMES.PAGE_TRANSLATIONS.role,
    },
    PAGE_CATALOG: {
        label: ROUTE_NAMES.PAGE_CATALOG.label,
        icon: ROUTE_NAMES.PAGE_CATALOG.iconName,
        to: ROUTE_NAMES.PAGE_CATALOG.routeName,
        role: ROUTE_NAMES.PAGE_CATALOG.role,
    },
};
